// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { focusFirstFocusableChild, getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var AppBarSpacerVue2 = {
  name: 'KendoAppBarSpacer',
  props: {
    width: [String, Number]
  },
  computed: {
    spacerClasses: function spacerClasses() {
      return {
        'k-appbar-spacer': true,
        'k-appbar-spacer-sized': this.width !== undefined
      };
    },
    spacerStyles: function spacerStyles() {
      return {
        flexBasis: this.width !== undefined ? this.width : undefined
      };
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return h("span", {
      "class": this.spacerClasses,
      style: this.spacerStyles
    }, [defaultSlot]);
  },
  methods: {
    focus: function focus() {
      if (this.$el) {
        focusFirstFocusableChild(this.$el);
      }
    }
  }
};
/**
 * @hidden
 */
var AppBarSpacer = AppBarSpacerVue2;
export { AppBarSpacer, AppBarSpacerVue2 };